exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar{\r\n    padding: 5px 20px;\r\n    border: none;\r\n    margin-bottom: -5px !important;\r\n}\r\n.navbar-brand{\r\n    font-size: 20px;\r\n    position: relative;\r\n    margin-left: 10px !important;\r\n}\r\n.div-body{\r\n    margin-top: 10px;\r\n    height: 550px;\r\n    padding: 20px 20px;\r\n}\r\n.popup-screen{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    background-color: rgba(0,0,0,0.5);\r\n}\r\n.navigation-row{\r\n    margin-top: 5px;\r\n    padding: 5px 5px;\r\n}\r\n.navigation-row div button{\r\n    text-align: center;\r\n    width: 120px;\r\n    height: 30px;\r\n    border-radius: 0px;\r\n}\r\n.routing-tab{\r\n    \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = 464
// module chunks = 1